import { RowSelectionState, Updater } from '@tanstack/react-table';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { RateOverview, useInvalidateRepositoryQueries } from '@mews-commander/data-access';
import { DropDownButton, DropdownItem, ListDivider } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { useResolveRoute } from '@mews/routing';
import { RouteName } from '@mews-commander/enums';
import { lt } from '@mews/framework';
import { navigateInModal } from '../../../../app/actions/common';
import { DeleteRatesDialog } from './DeleteRatesDialog';

interface RowActionsProps {
    rate: RateOverview;
    setRowSelection: (updater: Updater<RowSelectionState>) => void;
}

export const RowActions = ({ rate, setRowSelection }: RowActionsProps) => {
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const resolveRoute = useResolveRoute();
    const dispatch = useDispatch();
    const invalidateQueries = useInvalidateRepositoryQueries();

    const navigateToEditRate = () => {
        void invalidateQueries({ rates: ['getOverviewEntries'] });
        dispatch(navigateInModal(resolveRoute(RouteName.RateDetail, { rateId: rate.id })));
    };

    return (
        <>
            <DropDownButton icon={IconName.More} size="small" variant="ghost">
                <DropdownItem label={lt('Edit')} onClick={navigateToEditRate} />
                <ListDivider />
                <DropdownItem label={lt('Delete')} variant="danger" onClick={() => setIsDeleteDialogOpen(true)} />
            </DropDownButton>
            <DeleteRatesDialog
                rateIds={[rate.id]}
                onClose={() => setIsDeleteDialogOpen(false)}
                active={isDeleteDialogOpen}
                onDeleteSuccess={() => {
                    setRowSelection(({ [rate.id]: removed, ...otherSelection }) => otherSelection);
                }}
            />
        </>
    );
};
